<template>
	<div class="hd-moa-frame-callout">
		<base-image-svg
			class="js-moa-frame-callout hd-moa-frame-callout__svg"
			:source="require('!html-loader!../../assets/svgs/17-moa-frame-callout.svg')"
		/>
		<base-image-svg
			class="js-moa-frame-callout hd-moa-frame-callout__svg hd-moa-frame-callout__svg--mobile"
			:source="require('!html-loader!../../assets/svgs/17-moa-frame-callout-mobile.svg')"
		/>
	</div>
</template>

<style lang="scss" scoped>
	.hd-moa-frame-callout {
		position: absolute;
		left: 0;
		bottom: 0;
		@include box(100%);

		&__svg {
			&--mobile.hd-base-image-svg {
				display: none;
			}
		}

		:deep() svg {
			position: absolute;
			left: 0;
			@include center-y();
			width: 100%;
			max-height: 700px;
			@include fade-out();
			transform: translate(-5%, -45%);

			#secondary {
				@include fade-out();
				transform: translateX(15%);
			}

			#callout-wrapper {
				@include fade-out();
				transform: scale(0.3) translateX(50%);
				transform-origin: center;
			}
		}

		// Animations
		[data-state="animation-ready"] {
			:deep() svg {
				opacity: 1;
				transform: translate(0, -50%);

				#secondary {
					@include transition-frame-fade-in();
					transition-delay: 0.25s;
				}
				#callout-wrapper {
					opacity: 1;
					transform: scale(1) translateX(0%);
					transition-delay: 0.5s;
				}
			}
		}

		// Responsive
		@include res-screen-small {
			:deep() svg {
				max-height: 500px;
			}
		}
		@include res-screen-x-small {
			:deep() svg {
				max-height: 410px;
			}
		}

		@include res-screen-portrait-sm {
			&__svg {
				display: none;

				&--mobile.hd-base-image-svg {
					display: flex;
				}
			}

			:deep() svg {
				max-height: 350px;
			}
		}
	}
</style>

